import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

import { MakeShellClient, makeShellApiRef } from './api';
import { rootRouteRef } from './routes';
import { MAKE_SHELL_ROUTES } from './navigation';

const makeShellApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: makeShellApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new MakeShellClient({ discoveryApi, fetchApi }),
    }),
});

const makeShellPage = PageBlueprint.make({
  params: {
    path: MAKE_SHELL_ROUTES.root.path,
    title: 'Make Shell',
    routeRef: rootRouteRef,
    // The overview tabs and MFE detail page render their own BUI
    // <FullPage>/<Header>.
    noHeader: true,
    loader: () =>
      import('./components/MakeShellPage').then(m => <m.MakeShellPage />),
  },
});

export const makeShellPlugin = createFrontendPlugin({
  pluginId: 'make-shell',
  title: 'Make Shell',
  routes: {
    root: rootRouteRef,
  },
  extensions: [makeShellApi, makeShellPage],
});

export default makeShellPlugin;
